import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { FournisseurSession } from './etat/Session'
import { FournisseurToast } from './etat/Toast'
import { MiseAJour } from './composants/MiseAJour'
import { initTailleTexte } from './etat/tailleTexte'
import './styles/theme.css'

const racine = document.getElementById('racine')
if (!racine) throw new Error('Élément #racine introuvable')

initTailleTexte()

createRoot(racine).render(
  <StrictMode>
    <BrowserRouter>
      <FournisseurToast>
        <FournisseurSession>
          <App />
          <MiseAJour />
        </FournisseurSession>
      </FournisseurToast>
    </BrowserRouter>
  </StrictMode>,
)
